import { CalendarEvent } from './CalendarEvent'
import externalLink from './externalLink'
import locationAsHtml from './locationAsHtml'

export default function descriptionAsHtml(
    {
        excerpt = '',
        location = '',
        locationLink = '',
        eventPageUrl = '',
        videoCallUrl = '',
    }: CalendarEvent,
    {
        /**
         * MS doesn't render paragraph + paragraph with any margin
         * setting this to `true` will add additional `<br />` tags
         * to fix the spacing.
         */
        addBreak = false,
    } = {},
): string {
    return [
        excerpt,
        externalLink(eventPageUrl),
        locationAsHtml({ location, locationLink }),
        externalLink(videoCallUrl),
    ]
        .filter(Boolean)
        .map((value) => `<p>${value}</p>`)
        .join(addBreak ? '<br />' : '')
}

export function addBreak(): Partial<Parameters<typeof descriptionAsHtml>[1]> {
    return {
        addBreak: true,
    }
}
